import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { numbersTabs } from '../../shared/numbersTabs';

export default function NumberChargeGroups(props) {
    const data = {
        url: '/admin/numbers/charge-groups',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/numbers/charge-groups/{id}',
        userfilter: [
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'status',
                label: 'Status',
                type: 'select',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Charge group name'
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Description'
            },
            {
                label: 'Rate',
                source: 'rate',
                type: 'number',
                editable: false,
                default: 0,
                placeholder: '0.00'
            },
            {
                label: 'Currency',
                source: 'currency',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'USD'
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'Active',
                    false: 'Inactive'
                },
                classnames: {
                    true: 'label label-success',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                default: ''
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="Number Charge Groups">
            <>            
                <Tabs tabs={numbersTabs} />
                <DataResource
                    addButtonText="Create New Charge Group"
                    addButtonType="link"
                    addButtonLink="/numbers/charge-groups/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}
